var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-img"},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.description,"draggable":"false","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }